import { render, staticRenderFns } from "./Synonyms.vue?vue&type=template&id=4ecc0d65&lang=pug&"
import script from "./Synonyms.vue?vue&type=script&lang=js&"
export * from "./Synonyms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports